export interface IInkBarPositioner {
  left: string;
  width: string;
}

import { Directive, ElementRef, NgZone, Renderer2, HostBinding } from '@angular/core';

@Directive({
  selector: '[vcUnderline]'
})
export class UnderlineDirective {
  public underlineElement;

  constructor(private _renderer: Renderer2, private _elementRef: ElementRef<HTMLElement>, private _ngZone: NgZone) {}

  @HostBinding('class.underline')
  underlineClass = true;

  @HostBinding('style.opacity')
  opacity = 0;

  public alignToElement(element: HTMLElement) {
    this.show();

    if (typeof requestAnimationFrame !== 'undefined') {
      this._ngZone.runOutsideAngular(() => {
        requestAnimationFrame(() => this._setStyles(element));
      });
    } else {
      this._setStyles(element);
    }
  }

  /** Shows the ink bar. */
  public show(): void {
    this._renderer.setStyle(this._elementRef.nativeElement, 'opacity', 1);
  }

  /** Hides the ink bar. */
  public hide(): void {
    this._renderer.setStyle(this._elementRef.nativeElement, 'opacity', 0);
  }

  public _setStyles(element: HTMLElement) {
    const underLine: HTMLElement = this._elementRef.nativeElement;
    this._renderer.setStyle(underLine, 'width', `${element.offsetWidth - 26}px`);
    this._renderer.setStyle(underLine, 'left', `${element.offsetLeft}px`);
  }
}
